import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useInteractiveStateCombined } from '@bubble-ui/hook-use-interactive-state';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var Label = _ref => {
  var {
    id,
    isSelected,
    label,
    name,
    onChange,
    value
  } = _ref;
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var [interactiveState, eventHandlers] = useInteractiveStateCombined();
  var {
    keyboardFocusStyle,
    radioStyle,
    rootStyle,
    textStyle
  } = getDefaultStyleSheet({
    designContext,
    interactiveState: interactiveState.interactiveState,
    isSelected
  });
  return /*#__PURE__*/React.createElement(View, {
    id: ids === null || ids === void 0 ? void 0 : ids.root
  }, interactiveState.keyboardFocused && /*#__PURE__*/React.createElement(View, {
    style: keyboardFocusStyle
  }), /*#__PURE__*/React.createElement(View, _extends({
    tag: "label",
    style: rootStyle
  }, eventHandlers), /*#__PURE__*/React.createElement(Text, {
    id: ids === null || ids === void 0 ? void 0 : ids.text,
    style: textStyle
  }, label), /*#__PURE__*/React.createElement("input", {
    checked: isSelected,
    id: ids === null || ids === void 0 ? void 0 : ids.input,
    name: name,
    onChange: e => onChange(value, e),
    style: radioStyle,
    type: "radio",
    value: value
  })));
};
Label.displayName = 'MenuTabLabel';
export var MenuTabLabel = withProvisionalOverrideFromContext(Label);
//# sourceMappingURL=index.js.map